import { add } from "./base";
class Handler {
    toString(data) {
        return typeof data == "string" ? data : "";
    }
    fromString(value) {
        return typeof value == "string" && !!value ? value : undefined;
    }
    partialFormat = this.format;
    format(unformatted) {
        return {
            ...unformatted,
            type: "text",
            inputmode: "numeric",
            autocomplete: "cc-csc",
            length: [3, 3],
            pattern: /^\d{3}$/,
        };
    }
    unformat(formatted) {
        return formatted;
    }
    allowed(symbol, state) {
        return state.value.length < 3 && symbol >= "0" && symbol <= "9";
    }
}
add("card-csc", () => new Handler());
//# sourceMappingURL=card-csc.js.map